import { useMemo } from "react";
import {
  Chart as ChartJS, CategoryScale, LinearScale, BarElement,
  Title, Tooltip, Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const MONTHS_FULL  = ["Janeiro","Fevereiro","Março","Abril","Maio","Junho","Julho","Agosto","Setembro","Outubro","Novembro","Dezembro"];
const MONTHS_SHORT = ["Jan","Fev","Mar","Abr","Mai","Jun","Jul","Ago","Set","Out","Nov","Dez"];

const STATUSES = {
  pending:          { label: "Pendente",    color: "#e67e22", bg: "rgba(230,126,34,.8)"  },
  out_for_delivery: { label: "Em entrega",  color: "#2980b9", bg: "rgba(41,128,185,.8)"  },
  delivered:        { label: "Entregue",    color: "#27ae60", bg: "rgba(39,174,96,.8)"   },
};

export function DeliveryStatusChart({ orders, height = "250px" }) {
  const currentYear = new Date().getFullYear();

  const countsByStatus = useMemo(() => {
    const result = {};
    Object.keys(STATUSES).forEach(s => { result[s] = new Array(12).fill(0); });
    orders.forEach(o => {
      if (!o.paid || !STATUSES[o.delivery_status]) return;
      const d = new Date(o.updated_at);
      if (d.getFullYear() !== currentYear) return;
      const m = d.getMonth();
      result[o.delivery_status][m]++;
    });
    return result;
  }, [orders, currentYear]);

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    interaction: { mode: "index", intersect: false },
    plugins: {
      legend: {
        position: "top",
        labels: { font: { size: 11 }, usePointStyle: true, pointStyleWidth: 8, padding: 16, color: "#718096" },
      },
      tooltip: {
        backgroundColor: "rgba(0,0,0,.82)",
        titleFont: { size: 12, weight: "600" },
        bodyFont: { size: 11 },
        padding: 10,
        cornerRadius: 8,
      },
    },
    scales: {
      x: {
        stacked: true,
        grid: { color: "rgba(0,0,0,.04)" },
        ticks: { font: { size: 10 }, color: "#a0aec0" },
      },
      y: {
        stacked: true,
        grid: { color: "rgba(0,0,0,.04)" },
        ticks: { font: { size: 10 }, color: "#a0aec0", stepSize: 1 },
        beginAtZero: true,
      },
    },
  };

  const data = {
    labels: MONTHS_SHORT,
    datasets: Object.entries(STATUSES).map(([key, cfg]) => ({
      label: cfg.label,
      data: countsByStatus[key],
      backgroundColor: cfg.bg,
      borderColor: cfg.color,
      borderWidth: 1,
      borderRadius: 4,
    })),
  };

  return (
    <div style={{ height, width: "100%", position: "relative" }}>
      <Bar options={options} data={data} />
    </div>
  );
}
